import React, { ReactNode } from 'react';

import { Button } from '@mui/material';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

import classes from './ChallengeTitleBlock.module.scss';
import { ChallengeStatusType } from '../../constants/challengeStatus';
import { JoinChallengeButton } from '../JoinChallengeButton/JoinChallengeButton';

type ChallengeTitleBlockProps = {
  title: ReactNode;
  description: string | null;
  openButtonTitle: string;
  challengeId: string;
  challengeStatus: ChallengeStatusType;
  isRegistrationPeriod: boolean;
  onOpenButtonClick: () => void;
};

const ChallengeTitleBlock = ({
  title,
  description,
  openButtonTitle,
  challengeId,
  challengeStatus,
  isRegistrationPeriod,
  onOpenButtonClick,
}: ChallengeTitleBlockProps) => {
  return (
    <div className={classes.container}>
      <div className={classes.titleBlock}>
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      <div className={classes.buttons}>
        <JoinChallengeButton
          challengeId={challengeId}
          challengeStatus={challengeStatus}
          isRegistrationPeriod={isRegistrationPeriod}
        />
        <Button
          variant="text"
          color="white"
          endIcon={<ChevronRightRoundedIcon />}
          onClick={onOpenButtonClick}
        >
          {openButtonTitle}
        </Button>
      </div>
    </div>
  );
};

export { ChallengeTitleBlock };
